export function isCurrentPath(testPath) {
  const { pathname } = window.location
  return [testPath, testPath + '/'].includes(pathname)
}

export function currentPathIsAny(testPathArray) {
  return testPathArray.findIndex(testPath => isCurrentPath(testPath)) >= 0
}
